import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Layout from '../../Layaouts/layoutNoStepLeft';
import LoadButton from '../../loadButton/LoadButton';
import failImg from '../../../themed/images/undraw_cancel_re_pkdm_1.svg';

function Error404() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <Layout logoStep return>
      <div className="registration_form login_form">
        <h2 className="tittle">{t('Error 404, No se encuentra la página solicitada')}</h2>

        <div className="row">
          <div className="col-md-12 pt-4">
            <img src={failImg} className="aligncenter" alt="" />
          </div>
          <div className="col-md-12 pt-5 processing--register">
            <div className="form-group text-center m-y-16">
              <LoadButton text={t('Volver')} onClick={goHome} classNameButtom="m-auto" />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Error404;
